"use client";
import Image from "next/image";
import React, { useState } from "react";
import newsLatter from "../../public/assets/images/news-latter.png";
import { Col, Container, Row } from "react-bootstrap";
import "./components.css";
import CommonButton from "./CommonButton";
import CommonInput from "./CommonInput";
import { showToast } from "../../utils/libs/toast-utilis";
import { createNewsLatter } from "@/services/pricing";

const NewsLatter = () => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [emailError, setEmailError] = useState("");
  const handleSubmit = async (e) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      setEmailError("Email is required");
      return;
    }
    if (!emailRegex.test(email)) {
      setEmailError("Please enter a valid email address");
      return;
    }
    setEmailError("");
    setEmail("");
    try {
      const response = await createNewsLatter({ email: email });
      showToast.success("Thank you! Please check your inbox");
      setSubmitted(true);
      setTimeout(() => {
        setSubmitted(false);
      }, 5000);
    } catch (error) {
      showToast.error(error?.message ?? "Something went wrong");
    }
    // proceed with form submission
  };
  return (
    <div className="news-latter-main">
      {/* <Container> */}
      <Row>
        <Col lg={6}>
          <Image
            src={newsLatter}
            height={300}
            width={300}
            alt="news latter"
            className="img-fluid news-latter-img"
          />
        </Col>
        <Col lg={6} className="align-self-center">
          <h3 className="com-title">
            Stay Ahead in <span>Tech</span>
          </h3>
          <p className="">
            Get exclusive IT insights, cloud updates & more — straight to your
            inbox.
          </p>
          {submitted ? (
            <p className="newsletter-success">
              🎉Thank you! Please check your inbox.
            </p>
          ) : (
            <>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleSubmit();
                }}
              >
                <div className="news-input-main">
                  <input
                    className="contact-input"
                    type="text"
                    placeholder="Enter your email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <CommonButton
                    label="Subscribe"
                    className="btn-primary"
                    type="submit"
                    icon={
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                        style={{ height: "20px", fill: "#fff" }}
                      >
                        <path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" />
                      </svg>
                    }
                  />
                </div>
                {emailError && (
                  <small className="text-danger">{emailError}</small>
                )}
              </form>
            </>
          )}
        </Col>
      </Row>
      {/* </Container> */}
    </div>
  );
};

export default NewsLatter;
